var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['modal', _vm.active && 'active']},[_c('div',{staticClass:"modal-close",on:{"click":_vm.close}}),_c('div',{staticClass:"modal-container"},[(_vm.title)?_c('div',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }